import {
  CustomFormFieldObjectTypeTypes, EntityConnectionTypeDetailsFragment, EntityTypeDetailsFragment,
  TagType
} from 'generated/graphql';

import { getTagTypeIcon } from 'field-shared/field-helper-functions';
import { connectionTypeName } from 'helpers';

export class CustomFormFieldLabelIcons {
  static readonly DEFAULT: { icon: string; label: string } = { icon: null, label: null };

  public static LABELS_AND_ICONS = (entityType: EntityTypeDetailsFragment) => {

    const getDemographicsLabel = () => {
      const demoItems = [];
      if (entityType.dateOfBirthEnabled) {
        demoItems.push('DOB');
      }
      if (entityType.languageEnabled) {
        demoItems.push('Language');
      }

      if (demoItems.length < 1) {
        return 'Demographics';
      }

      return `Demographics (${demoItems.join(' / ')})`;

    };

    return {
      name: { icon: 'fa-person', label: entityType.pronounsEnabled ? 'Name / Pronouns' : 'Name' },
      // now "all languages" but keep preferred for backwards compat
      preferred_language: { icon: 'fa-globe-americas', label: 'Language(s)' },
      date_of_birth: { icon: 'fa-birthday-cake', label: 'Date of Birth' },
      email: { icon: 'fa-envelope', label: 'Email Address' },
      phone_number: { icon: 'fa-phone', label: 'Phone Number' },
      address: { icon: 'fa-map-marker-alt', label: 'Address' },
      note: { icon: 'fa-sticky-note', label: 'Entity Note' },
      assessment: { icon: 'fa-sliders-h', label: 'Assessment' },
      social_profile: { icon: 'fa-link-horizontal', label: 'Social Media Profile' },
      tag_category: (tagCategory: { name: string; allowToCreateTagType: TagType }) => ({
        label: tagCategory.name,
        icon: getTagTypeIcon(tagCategory.allowToCreateTagType)
      }),
      entity_connection_type: (entityConnectionType: EntityConnectionTypeDetailsFragment) => ({
        label: connectionTypeName(entityConnectionType),
        icon: 'fa-share-alt'
      }),
    };
  };

  static getIconAndLabel(entityType: EntityTypeDetailsFragment, customFormField: {
    fieldObjectType: CustomFormFieldObjectTypeTypes;
    fieldObjectId?: string;
    objectAttribute?: string;
    tagCategory?: { name: string; allowToCreateTagType: TagType };
    entityConnectionType?: EntityConnectionTypeDetailsFragment;
  }) {
    switch (customFormField.fieldObjectType) {
      case CustomFormFieldObjectTypeTypes.Entity:
        return this.getLabelForEntity(entityType, customFormField.objectAttribute);
      case CustomFormFieldObjectTypeTypes.EntityConnectionType:
        return this.LABELS_AND_ICONS(entityType).entity_connection_type(customFormField.entityConnectionType);
      case CustomFormFieldObjectTypeTypes.PhoneNumber:
        return this.LABELS_AND_ICONS(entityType).phone_number;
      case CustomFormFieldObjectTypeTypes.Email:
        return this.LABELS_AND_ICONS(entityType).email;
      case CustomFormFieldObjectTypeTypes.Address:
        return this.LABELS_AND_ICONS(entityType).address;
      case CustomFormFieldObjectTypeTypes.TagCategory:
        return this.LABELS_AND_ICONS(entityType).tag_category(customFormField.tagCategory);
      case CustomFormFieldObjectTypeTypes.GlobalNote:
        return this.LABELS_AND_ICONS(entityType).note;
      default:
        return this.DEFAULT;
    }
  }

  private static getLabelForEntity(entityType: EntityTypeDetailsFragment, attribute: string) {
    switch (attribute) {
      case 'assessment':
        return this.LABELS_AND_ICONS(entityType).assessment;
      case 'name':
        return this.LABELS_AND_ICONS(entityType).name;
      case 'date_of_birth':
        return this.LABELS_AND_ICONS(entityType).date_of_birth;
      case 'preferred_language':
        return this.LABELS_AND_ICONS(entityType).preferred_language;
      case 'social_profile':
        return this.LABELS_AND_ICONS(entityType).social_profile;
      default:
        return this.DEFAULT;
    }
  }

}
